<mat-card style="min-height: 700px">
  <app-card-header title="User Management" subtitle="IRB Users" [ngClass]="routeAnimationsElements">
  </app-card-header>

  <mat-card-content class="p-3">
    <div class="search-div">
      <!-- Filter Section -->
      <form [formGroup]="researcherService.filterForm" novalidate (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-3">
            <mat-form-field appearance="fill">
              <mat-label>Search by Role</mat-label>
              <mat-select formControlName="role">
                <mat-option *ngFor="let role of availableRoles" [value]="role.value">
                  {{ role.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="fill">
              <mat-label>Search by Last Name</mat-label>
              <input formControlName="lastName" matInput placeholder="Last Name">
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="fill">
              <mat-label>Search by First Name</mat-label>
              <input formControlName="firstName" matInput placeholder="First Name">
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="fill">
              <mat-label>Search by User Status</mat-label>
              <mat-select formControlName="isActive">
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <button type="button" class="mr-3" mat-stroked-button color="warn" aria-label="Clear Search"
            (click)="resetFilter()">
            Clear Search
          </button>
          <button type="submit" class="mr-3" mat-stroked-button color="primary" aria-label="Search">
            Search
          </button>
          <div class="button-container">
              <span class="spinner-container" *ngIf="excelLoading">
                  <mat-spinner diameter="24"></mat-spinner>
              </span>
              <button mat-stroked-button color="accent" type="button"  [disabled]="excelLoading" (click)="downloadExcel()">Download
                Excel</button>
          </div>
        </div>
      </form>
    </div>

    <!-- Add Buttons -->
    <div fxLayout="row" fxLayoutAlign="end center" class="mb-2">
      <button mat-stroked-button color="accent" (click)="addResearcher()">
        <mat-icon class="mb-1">add</mat-icon>Add User
      </button>
    </div>

    <!-- Table Section -->
    <div class="table-container">
      <div *ngIf="isLoading" style="position: absolute; right: 50%; top: 35%;">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </div>
      <div>
        <mat-paginator #topPaginator [length]="researcherService.totalCount" [pageSize]="researcherService.pageSize"
          [pageSizeOptions]="[10, 20, 30]" [pageIndex]="researcherService.pageIndex" (page)="onPageChange($event)">
        </mat-paginator>

        <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
          [matSortActive]="researcherService.sortActive" [matSortDirection]="researcherService.sortDirection"
          class="mat-elevation-z8 mt-3">

          <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.lastName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>First Name</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.firstName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.email }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef>Phone</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ formatPhone(element.phone) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="role">
            <mat-header-cell *matHeaderCellDef>Role</mat-header-cell>
            <mat-cell *matCellDef="let e" class="role-cell">
              <div class="roles">
                <span *ngFor="let r of e.researcherRoles;">
                  {{ r.isActive ? formatRoleName(r.role) : '' }}
                </span>
              </div>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="isActive">
            <mat-header-cell *matHeaderCellDef mat-sort-header>User Status</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ hasActiveRole(element) ? 'Active' : 'Inactive' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container>
                <button *ngIf="element.isActive" class="mr-2" mat-stroked-button color="accent" aria-label="Edit User"
                  (click)="edit(element)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-stroked-button color="warn" aria-label="Delete User" (click)="remove(element)" *ngIf="hasActiveRole(element)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </ng-container>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <div *ngIf="dataSource.data.length === 0 && !isLoading"
          style="color: #CCD1D1; text-align: center; padding: 20px;">
          <span>No Users found</span>
        </div>

        <mat-paginator [length]="researcherService.totalCount" [pageSize]="researcherService.pageSize"
          [pageSizeOptions]="[10, 20, 30]" [pageIndex]="researcherService.pageIndex" (page)="onPageChange($event)">
        </mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>
